/** Word-level IPA overrides for Icelandic. */
export const is: Record<string, string> = {
  ásir: '/ˈauːsɪr/',
  ásynjur: '/ˈauːsɪnjʏr/',
  ballir: '/ˈpatlɪr/',
  beytils: '/ˈpeiːtʰɪls/',
  Bjálfa: '/ˈpjaulva/',
  Bjarnar: '/ˈpjartnar/',
  blót: '/plouːtʰ/', // sacrifice/ritual
  bóklaus: '/ˈpoukʰlœys/',
  bréfberi: '/ˈprjɛːvpɛrɪ/', // letter carrier
  burlufóts: '/ˈpʏrtlʏfouts/',
  eflaði: '/ˈɛplaðɪ/', // past tense: strengthened/performed
  ek: '/ɛkʰ/',
  fannhvítir: '/ˈfanːkvitʰɪr/',
  farandi: '/ˈfarantɪ/',
  farsælda: '/ˈfarsailta/',
  fira: '/ˈfɪra/',
  flatnefur: '/ˈflatnɛvʏr/',
  flýðu: '/ˈfliːðʏ/',
  fornaldar: '/ˈfɔrtnaltar/',
  fornrit: '/ˈfɔrtnrɪtʰ/',
  galdursmenn: '/ˈkaltʏrsmɛnː/',
  gautr: '/ˈkœyːtr/',
  // New saga/literary overrides
  gengr: '/kɛŋkr/',
  goðorðsmaður: '/ˈkɔːðɔrðsmaːðʏr/',
  hængs: '/ˈhaiŋs/',
  hagsælda: '/ˈhaksailta/',
  Hálfdanarsonar: '/ˈhaulfˌtanarˌsɔnar/',
  hálftrölls: '/ˈhaulftrœtls/',
  Hallbjarnar: '/ˈhatlpjartnar/',
  Hallfreðs: '/ˈhatlfrɛðs/', // genitive of Hallfreður
  Hallfreður: '/ˈhatlfrɛðʏr/', // proper name
  hárfagra: '/ˈhaurˌfaɣra/', // fair-haired (epithet)
  hárfagri: '/ˈhaurˌfaɣrɪ/',
  hersir: '/ˈhɛrsɪr/',
  hersis: '/ˈhɛrsɪs/',
  herskarar: '/ˈhɛrskʰarar/',
  Hrafnkelsdal: '/ˈr̥apnkʰɛlstalr/', // place name
  Hreggviðsson: '/ˈr̥ɛkːvɪðsːɔn/',
  hrímhvíta: '/ˈr̥imkvitʰa/',
  Ingólfr: '/ˈɪŋkoulfr/',
  ins: '/ɪns/',
  Ívarssonar: '/ˈivarsːɔnar/',
  jöklanna: '/ˈjœkʰlanːa/',
  Jórsalalands: '/ˈjourtsalalants/',
  Ketils: '/ˈkʰɛtʰɪls/',
  kindir: '/ˈkʰɪntɪr/',
  Kólumkilli: '/ˈkʰouːlʏmkʰɪtlɪ/',
  konungdæmi: '/ˈkʰɔːnʏŋˌtaiːmɪ/',
  konungdómur: '/ˈkʰɔːnʏŋˌdouːmʏr/',
  konungr: '/ˈkʰɔːnʏŋkr/',
  konungseigninni: '/ˈkʰɔːnʏŋkseiknɪnːɪ/',
  kotbóndi: '/ˈkʰɔtʰpountɪ/',
  kunnigt: '/ˈkʰʏnːɪkʰtʰ/',
  kvongaður: '/ˈkʰvɔŋkaðʏr/',
  kynstór: '/ˈkʰɪnstouːr/',
  maðr: '/maːðr/',
  magra: '/ˈmaɣra/',
  manndáðin: '/ˈmanːtauːðɪn/',
  mannfólkit: '/ˈmanːfoukʰɪtʰ/',
  mjök: '/mjœkʰ/',
  mögu: '/ˈmœːkʏ/',
  nórrænn: '/ˈnouːrraiːnː/',
  Nörvasundum: '/ˈnœrvasʏntʏm/',
  Norvegi: '/ˈnɔrvɛjɪ/',
  nýu: '/ˈniːʏ/',

  óarga: '/ˈouːarka/',
  Önundur: '/ˈœːnʏntʏr/',
  or: '/ɔr/',
  ór: '/ouːr/',
  öxn: '/ˈœksn/',
  plógsland: '/ˈpʰlouːkslant/',
  ráðu: '/ˈrauːðʏ/',
  rækir: '/ˈraiːkʰɪr/',
  Raumaríki: '/ˈrœyːmarɪːkʰɪ/',
  Raumsdælafylki: '/ˈrœymstailafɪlkʰɪ/',
  Raumsdal: '/ˈrœymstal/',
  raumur: '/ˈrœyːmʏr/',
  Rein: '/reiːn/',
  sannliga: '/ˈsanːlɪɣa/',
  Skíðason: '/ˈskiːðasɔn/',
  söðul: '/ˈsœːðʏl/',
  sólkerfum: '/ˈsoulkʰɛrvʏm/',
  tindar: '/ˈtʰɪntar/',
  útsjánum: '/ˈuːtʰsjauːnʏm/',
  vágskorin: '/ˈvauɣskɔrɪn/',
  Valföðr: '/ˈvalvœðr/',
  víkverskur: '/ˈviːkvɛrskʏr/',
  Yngveldi: '/ˈɪŋkvɛltɪ/',
  þat: '/θatʰ/',
};
